//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionWithFilter from '../../components/SectionWithFilter.vue'
import StocksControlledTools from '../../pages/main/sections/Stock/StocksControlledTools.vue'
import StockControlJournal from '../../pages/main/sections/Stock/StockControlJournal.vue'

export default {
  name: 'StockCardSectionControl',
  components: {
    SectionWithFilter,
    StocksControlledTools,
    StockControlJournal
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    objectSrc: {
      type: Object,
      default: null
    }
  },
  data: function () {
    const formId = 'stockCardControlledTools'

    return {
      loading: false,

      formId: formId,
      filterConfig: null,

      selectedTabKey: null,
      selectedTabStorageProperty: formId + '.tab',
      tabs: [{
        key: 'controlledTools',
        name: 'Контролируемые позиции',
        filterConfig: {
          filterName: 'ФИЛЬТР КОНТРОЛИРУЕМЫХ НОМЕНКЛАТУРНЫХ ПОЗИЦИЙ',
          filterType: 'controlledTool',
          filterFormId: formId,
          filterUnavailable: false
        }
      }, {
        key: 'controlJournal',
        name: 'Журнал контроля',
        filterConfig: {
          filterName: 'ФИЛЬТР ЖУРНАЛА КОНТРОЛЯ НОМЕНКЛАТУРНЫХ ПОЗИЦИЙ',
          filterType: 'stockControlRecord',
          filterFormId: formId,
          filterUnavailable: false,
          filterDefaultValues: {
            stockId: this.objectSrc && this.objectSrc.id || null
          }
        }
      }]
    }
  },
  computed: {
    objectId: function () {
      return this.objectSrc && this.objectSrc.id || null
    }
  },
  watch: {
    selectedTabKey: function (value) {
      if (value) {
        localStorage.setItem(this.selectedTabStorageProperty, value)

        const selectedTab = this.tabs.find(tab => tab.key === value)
        this.filterConfig = selectedTab.filterConfig
      }
    },
    objectSrc: {
      handler: function (object) {
        this.onObjectChanged(object)
      },
      immediate: true
    }
  },
  created: function () {
    let selectedTabKey = localStorage.getItem(this.selectedTabStorageProperty) || null
    if (selectedTabKey && !this.tabs.some(tab => tab.key === selectedTabKey)) {
      localStorage.removeItem(this.selectedTabStorageProperty)
      selectedTabKey = null
    }
    if (!selectedTabKey && this.tabs.length) {
      selectedTabKey = this.tabs[0].key
    }
    this.selectedTabKey = selectedTabKey
  },
  methods: {
    onObjectChanged: function (object) {
      const tabComponent = this.$refs.tabComponent
      if (tabComponent && tabComponent.onUpdate) {
        tabComponent.onUpdate()
      }
    },
    onLoadingChange: function (value) {
      this.loading = value
    }
  }
}
